export default __webpack_public_path__ + "static/media/bg-image.55a4cfee.svg";